import { SUPPORT_LINK } from './environment.constants';
import { EnvName } from './models/env-name.enum';
import { EnvironmentModel } from './models/environment.model';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvironmentModel = {
  production: false,
  useMocks: false,
  envName: EnvName.DEV,
  apiHost: 'https://dev2.iiiwallet.com/api/v1/',
  authApiUrl: 'https://dev2.iiiwallet.com/auth/',
  assetsHost: '',
  supportLink: SUPPORT_LINK,
  amlSupportLink: 'https://hglobal.enterprise.slack.com/archives/C095V104QTU',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
